/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ProcessMedicationFileByPatientId201Response
 */
export interface ProcessMedicationFileByPatientId201Response {
    /**
     * 
     * @type {string}
     * @memberof ProcessMedicationFileByPatientId201Response
     */
    message?: string;
    /**
     * 
     * @type {string}
     * @memberof ProcessMedicationFileByPatientId201Response
     */
    requestId?: string;
}

/**
 * Check if a given object implements the ProcessMedicationFileByPatientId201Response interface.
 */
export function instanceOfProcessMedicationFileByPatientId201Response(value: object): value is ProcessMedicationFileByPatientId201Response {
    return true;
}

export function ProcessMedicationFileByPatientId201ResponseFromJSON(json: any): ProcessMedicationFileByPatientId201Response {
    return ProcessMedicationFileByPatientId201ResponseFromJSONTyped(json, false);
}

export function ProcessMedicationFileByPatientId201ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProcessMedicationFileByPatientId201Response {
    if (json == null) {
        return json;
    }
    return {
        
        'message': json['message'] == null ? undefined : json['message'],
        'requestId': json['requestId'] == null ? undefined : json['requestId'],
    };
}

export function ProcessMedicationFileByPatientId201ResponseToJSON(json: any): ProcessMedicationFileByPatientId201Response {
    return ProcessMedicationFileByPatientId201ResponseToJSONTyped(json, false);
}

export function ProcessMedicationFileByPatientId201ResponseToJSONTyped(value?: ProcessMedicationFileByPatientId201Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'message': value['message'],
        'requestId': value['requestId'],
    };
}

